import React from 'react'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'

export const NativeUpgradeRequiredAlert = () => {
  return (
    <InfoBox
      color='orange'
      size='md'
      aria-labelledby='native-upgrade-required-text'
      aria-live='polite'
    >
      <span id='native-upgrade-required-text'>
        To use this payment method you will need to upgrade the TABTouch app to the latest version
      </span>
    </InfoBox>
  )
}
